import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d10baae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-contol-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Makeup function is only possible when there are two pictures. (Not available if there are more than 3 pictures) ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Make up")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Please set the first picture as the one to put on makeup and adjust it to the 'Control panel'. ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Generate")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Only 2 photos can be adjusted in detail. If more than 3 photos, only the reflection ratio can be adjusted. ")
const _hoisted_7 = { style: {"display":"flex","align-items":"center","justify-content":"space-between"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Result", -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Create ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_MediaCards = _resolveComponent("MediaCards")!
  const _component_table_list = _resolveComponent("table-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MediaCards, {
      ref: "mediaCardRef",
      type: [
        {
          name: 'image',
          props: {
            title: 'Faces',
            search: true,
            uploaderProps: { max: 10, min: 2, isTemp: true },
          },
          event: { change: _ctx.onChangeImage, select: _ctx.onSelectImage },
        },
        {
          name: 'MakeupControlCard',
          props: {
            fileLength: _ctx.fileLength,
          },
        },
      ]
    }, {
      guide: _withCtx(() => [
        _createVNode(_component_a_typography_text, null, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_a_typography_title, { level: 5 }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_a_typography_text, null, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_a_typography_title, { level: 5 }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_a_typography_text, null, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_card, null, {
          title: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_a_button, {
                loading: _ctx.isLoading,
                type: "primary",
                disabled: _ctx.getDisableSubmit,
                onClick: _ctx.onClick
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }, 8, ["loading", "disabled", "onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["type"]),
    _createVNode(_component_table_list, {
      ref: "tableListRef",
      columns: _ctx.columns,
      apis: { list: _ctx.apiUrl },
      type: "image",
      "table-handler-props": { mode: ['download'] }
    }, null, 8, ["columns", "apis"])
  ]))
}